import PropTypes from "prop-types";

export const tableColumns = PropTypes.shape({
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  keys: PropTypes.arrayOf(PropTypes.string).isRequired,
});
